import { useEffect, useState } from 'react';

// Which columns a document shows: Rate, Quantity, Item totals.
//
// Julian's ask, from Joist: not every job wants its workings shown. A fixed
// price for "replace the gate" is a number the customer agreed to; printing
// "3 hrs × $85" underneath invites a conversation about the hourly rate rather
// than about the gate. Other jobs are the opposite — a materials-heavy quote
// reads as fair precisely because the quantities are on it.
//
// So it is a choice, per person, and it applies on BOTH sides: the technician
// looking at their own estimate and Julian printing a document for a customer.
//
// Kept on the device rather than the server, the same as the language switch:
// it is a preference about how something is displayed, not a fact about the
// job, and it must apply instantly to a document already on screen.

const KEY = 'qps-display-options';
const DEFAULTS = { rate: true, qty: true, itemTotals: true };

// Everything currently mounted that cares — a document, a sheet, the dialog
// itself. A change has to repaint all of them at once, or the printed page and
// the screen disagree.
const listeners = new Set();

export function readDisplayOptions() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || '{}');
    return { ...DEFAULTS, ...saved };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveDisplayOptions(next) {
  const merged = { ...readDisplayOptions(), ...next };
  try { localStorage.setItem(KEY, JSON.stringify(merged)); } catch { /* private mode */ }
  listeners.forEach(fn => fn(merged));
  return merged;
}

export function useDisplayOptions() {
  const [opts, setOpts] = useState(readDisplayOptions);
  useEffect(() => {
    listeners.add(setOpts);
    return () => { listeners.delete(setOpts); };
  }, []);
  return opts;
}

export { DEFAULTS as DISPLAY_DEFAULTS };
